const services = {
  isLogin: {
    url: '/api/isLogin',
    desc: '判断是否登录',
  },
  getBoardInfo: {
    method: 'post',
    url: '/api/board/getBoardInfo',
    desc: 'ホームページ画面',
  },
  getMyPetsInfo: {
    method: 'post',
    url: '/api/myPets/getMyPetsInfo',
    desc: 'オーナー・マイページ画面 初期処理',
  },
  deletePetInfo: {
    method: 'post',
    url: '/api/myPets/deletePetInfo',
    desc: 'オーナー・マイページ画面 削除ボタン押下',
  },
  getMyPetHomeInfo: {
    method: 'post',
    url: '/api/myPetHome/getMyPetHomeInfo',
    desc: 'ペット・マイページ画面 初期処理',
  },
  savePetInfo: {
    method: 'post',
    url: '/api/myPetHome/savePetInfo',
    desc: 'ペット・マイページ画面 保存ボタン押下',
  },
  stopPetCare: {
    method: 'post',
    url: '/api/myPetHome/stopPetCare',
    desc: 'ペット・マイページ画面 飼育中止ボタン押下',
  },
  // download: {
  //   method: 'post',
  //   url: '/api/myPetHome/download',
  //   desc: 'ペット・マイページ画面 ダウンロードボタン押下',
  // },
  uploadKettoshoFile: {
    method: 'post',
    url: '/api/myPetHome/uploadKettoshoFile',
    desc: 'ペット・マイページ画面 血統証アップロードボタン押下',
  },
  uploadImageFile: {
    method: 'post',
    url: '/api/myPetHome/uploadImageFile',
    desc: 'ペット・マイページ画面 画像アップロードボタン押下',
  },
  updateKoukaiFlg: {
    method: 'post',
    url: '/api/myPetHome/updateKoukaiFlg',
    desc: 'ペット・マイページ画面 公開権限更新ボタン押下',
  },
  deletePetPhoto: {
    method: 'post',
    url: '/api/myPetHome/deletePetPhoto',
    desc: 'ペット・マイページ画面 削除ボタン押下',
  },
  login: {
    method: 'post',
    url: '/api/login',
    desc: '登录',
  },
  toInfo: {
    method: 'post',
    url: '/api/toInfo',
    desc: '棟',
  },
  toCode: {
    method: 'post',
    url: '/api/toCode',
    desc: 'code',
  },
  careRules: {
    method: 'post',
    url: '/api/care-rules',
    desc: 'rules',
  },
  sendMail: {
    method: 'post',
    url: '/api/OwnerRigest/sendMail',
    desc: '新規ペットオーナー登録画面 送信',
  },
  ownerRigest: {
    method: 'post',
    url: '/api/OwnerRigest/ownerRigest',
    desc: '新規ペットオーナー登録 利用申込',
  },
  getOwnerInfo: {
    method: 'post',
    url: '/api/getOwnerInfo',
    desc: 'ペットオーナー情報',
  },
  updateOwnerInfo: {
    method: 'post',
    url: '/api/updateOwnerInfo',
    desc: 'ペットオーナー情報',
  },
  petRigest: {
    method: 'post',
    url: '/api/petRigest',
    desc: '新規ペット登録',
  },
  getTempPetInfo: {
    method: 'post',
    url: '/api/getTempPetInfo',
    desc: '一時保存データ取得',
  },
  getPetHealthInfo: {
    method: 'post',
    url: '/api/petHealth/getPetHealthInfo',
    desc: 'ペット体調管理画面 初期処理',
  },
  savePetHealthInfo: {
    method: 'post',
    url: '/api/petHealth/savePetHealthInfo',
    desc: 'ペット体調管理画面 保存ボタン押下',
   },
   deletePetHealthInfo: {
    method: 'post',
    url: '/api/petHealth/deletePetHealthInfo',
    desc: 'ペット体調管理画面 削除ボタン押下',
  },
  logout: {
    method: 'post',
    url: '/api/logout',
    desc: '登出',
  },
  remindPassword: {
    method: 'post',
    url: '/api/password/remind',
    desc: '重置密码メール',
  },
  resetPassword: {
    method: 'post',
    url: '/api/password/reset',
    desc: '重置密码',
  },
  updatePassword: {
    method: 'post',
    url: '/api/password/update',
    desc: '修改密码',
  },
  manshonRegist: {
    method: 'post',
    url: '/api/manshonRegist',
    desc: 'わんにゃんメイト申込',
  },
  downloadDirectDebitPdf: {
    method: 'post',
    url: '/api/downloadDirectDebitPdf',
    desc: '銀行口座振替PDFダウンロード',
  },
  inquary: {
    method: 'post',
    url: '/api/inquary',
    desc: 'お問い合わせ',
  },
//   inquirySendMail: {
//     method: 'post',
//     url: '/api/user/inquiryMail',
//     desc: '問い合わせメール(送信)',
//   },
//   getCourseList: {
//     url: '/api/course/list',
//     desc: '获取课程列表',
//   },
//   getCourseDetail: {
//     url: '/api/course/detail',
//     desc: '获取课程详细',
//   },
//   applyCourse: {
//     method: 'post',
//     url: '/api/course/reg',
//     desc: '申请课程',
//   },
//   getSubjectDetail: {
//     url: '/api/course/subject/detail',
//     desc: '获取教科详细',
//   },
//   getUnitDetail: {
//     url: '/api/course/subject/unit/detail',
//     desc: '获取单元详细',
//   },
//   getMaterialDetail: {
//     url: '/api/course/subject/unit/material/detail',
//     desc: '获取教材详细',
//   },
//   downloadCertificate: {
//     method: 'downloadPost',
//     url: '/api/course/certificate',
//     desc: '下载修了证',
//   },
//   getSubjectList: {
//     url: '/api/getSubjectList',
//     desc: '获取教科列表',
//   },
//   getUnitList: {
//     url: '/api/getUnitList',
//     desc: '获取单元列表',
//   },
//   getMaterialList: {
//     url: '/api/getMaterialList',
//     desc: '获取教材列表',
//   },
//   getMyCourseList: {
//     url: '/api/mypage/courselist',
//     desc: '获取我的课程列表',
//   },
//   getInformationList: {
//     url: '/api/mypage/infolist',
//     desc: '获取我的消息列表',
//   },
//   getInformationDetail: {
//     url: '/api/mypage/info',
//     desc: '获取我的消息详情',
//   },
//   getQaList: {
//     url: '/api/getQaList',
//     desc: '获取我的问答列表',
//   },
//   getQaDetail: {
//     url: '/api/getQaDetail',
//     desc: '获取我的问答详情',
//   },
//   getMyProfile: {
//     url: '/api/mypage/user',
//     desc: '获取我的资料',
//   },
//   setMyProfile: {
//     method: 'post',
//     url: '/api/mypage/user/update',
//     desc: '修改我d资料',
//   },
//   getMyZipInfo: {
//     method: 'post',
//     url: '/api/mypage/zipInfo',
//     desc: '获取邮编信息',
//   },
//   getTestList: {
//     method: 'post',
//     url: '/api/course/subject/unit/test',
//     desc: '获取测试题',
//   },
//   submitTest: {
//     method: 'post',
//     url: '/api/course/subject/unit/test/next',
//     desc: '提交测试题答案',
//   },
//   submitTestLast: {
//     method: 'post',
//     url: '/api/course/subject/unit/test/submit',
//     desc: '提交测试题最后答案',
//   },
//   endTimeUpdate: {
//     method: 'post',
//     url: '/api/course/subject/unit/material/endTimeUpdate',
//     desc: 'endTimeUpdate',
//   },
//   getTeachingMaterialByCourseList: {
//     method: 'post',
//     url: '/api/course/getTeachingMaterialByCourseList',
//     desc: 'getTeachingMaterialByCourseList',
//   },
//   getTeachingMaterialShow: {
//     method: 'post',
//     url: '/api/course/getTeachingMaterialShow',
//     desc: 'getTeachingMaterialShow',
//   },
//   getTeachingMaterialByStudent: {
//     url: '/api/course/getTeachingMaterialByStudent',
//     desc: 'getTeachingMaterialByStudent',
//   },
//   download: {
//       method: 'downloadPost',
//       url: '/api/course/subject/unit/material/download',
//       desc: 'download',
//   },
//   noPassedAnsweres: {
//     method: 'post',
//     url: '/api/course/subject/unit/test/noPassedAnsweres',
//     desc: '不合格問題一覧',
//   },
};

export default services;
